import { useState } from 'react';
import { useDebouncedEffect } from './useDebouncedEffect';

/**
 * Takes in a value and a delay time in ms.
 * Whenever the value is changed, the useDebouncedState custom value will return the changed state after the debounce delay has been reached.
 * returns the debouncedValue, the up-to-date value, and the value setter
 *
 * @param initialValue - the initial value of the state
 * @param delay - the delay in ms to wait before updating the debounced value
 */
export const useDebouncedState = <T = any>(
  initialValue: T,
  delay: number,
): [T, T, (arg: T) => void] => {
  // state and setters for the value.
  const [value, setValue] = useState<T>(initialValue);
  // state and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useDebouncedEffect(
    () => {
      setDebouncedValue(value);
    },
    [value],
    { skipEffectOnMount: true, debounceTimeout: delay },
  );

  return [debouncedValue, value, setValue];
};
